const Subscriptions : React.FC = () => {
    return (
        <>
        <p>Abonnement</p>
        </>
    )
}

export default Subscriptions;